package com.catbit.opinionpoll.core.strings

enum class StringLocale(val languageCode: String) {
    EN_US("en-US"),
    PT_BR("pt-BR")
}